import { InvoicePermissionKey, PurchaseDocTab } from "types/InvoiceInbox";

/**
 * The register's tabs — a small module of its own (not living inside
 * invoice-inbox.tsx) so the month tree can import the same labels for its
 * "Patvirtintos: 8" header count and status pills without a circular import
 * between the two containers. One list, no duplicated strings.
 */
export const TABS: Array<{ id: PurchaseDocTab; labelKey: string }> = [
  { id: "needs_review", labelKey: "invoice_inbox_tab_needs_review" },
  { id: "awaiting_approval", labelKey: "invoice_inbox_tab_awaiting" },
  { id: "approved", labelKey: "invoice_inbox_tab_approved" },
  // Approved-and-not-yet-entered's other half: an approved document that
  // already has bookkeptAt set (erp-backend's split of what used to be one
  // 'approved' tab) — the accountant's to-enter queue vs. what is done.
  { id: "bookkept", labelKey: "invoice_inbox_tab_bookkept" },
  { id: "rejected", labelKey: "invoice_inbox_tab_rejected" },
  { id: "all", labelKey: "invoice_inbox_tab_all" },
  { id: "deleted", labelKey: "invoice_inbox_tab_deleted" },
];

export const TAB_LABEL_KEYS: Record<PurchaseDocTab, string> = TABS.reduce((acc, tab) => {
  acc[tab.id] = tab.labelKey;
  return acc;
}, {} as Record<PurchaseDocTab, string>);

/**
 * Who can move each tab's queue — the permission(s) behind the tab's action,
 * in the order the strip above the tabs lists them. Mirrors what erp-backend
 * actually enforces (InvoiceApprovalService / the docs/* controllers), not
 * what would be tidy: marking "entered" and "paid" is open to anyone with
 * register access by the owner's decision, while sending for approval is in
 * practice the accountant's act (sending decides the sender's accountant
 * slot, and the slot's holder must hold the accountant permission).
 * The label lives at i18n `invoice_inbox_actors_<tab>_<key>`.
 */
export const TAB_ACTORS: Record<PurchaseDocTab, InvoicePermissionKey[]> = {
  needs_review: ["approveAccountant", "verifyBankChange"],
  awaiting_approval: ["approveManager", "approveAccountant"],
  approved: ["access"],
  bookkept: ["access"],
  rejected: ["approveAccountant"],
  all: ["access"],
  exported: ["access"],
  deleted: ["access"],
};

export function tabActorLabelKey(tab: PurchaseDocTab, key: InvoicePermissionKey): string {
  return `invoice_inbox_actors_${tab}_${key}`;
}
